<template>
	<router-view
		:key="$route.query.key ?? $route.path"
	></router-view>
</template>
